// Email validation regex
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

// Password validation regex - at least 8 characters, 1 lowercase, 1 uppercase, 1 number
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9]).{8,}$/;

// Verification code regex - Cognito codes are numeric only, typically 6 digits
export const VERIFICATION_CODE_REGEX = /^[0-9]{6}$/;